import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, FormGroup, Label, Input } from 'reactstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';
import qs from 'qs';

import PasswordApi from 'apis/Password';
import { showFormErrors, showInputError } from 'utils/formvalidate.js';
import { inputFocusHandler } from 'utils/userFormValidate';

import 'assets/scss/components/password.css';
import 'assets/scss/formvalidate.css';

import PasswordContainer from 'components/users/Password';

class ResetPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      password: '',
      confirmPassword: '',
      loading: false,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  onChange = e => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleSubmit = event => {
    event.preventDefault();
    this.setState({ loading: true });
    const queryParams = qs.parse(this.props.location.search);
    const resetToken = queryParams['?reset_token'];

    const { password } = this.state;
    const { history } = this.props;
    let that = this;

    PasswordApi.update(password, resetToken)
      .then(function (response) {
        toast.success(() => {
          return (
            <div>
              <FontAwesomeIcon icon="check-circle" />
              Your Password has been successfully changed
            </div>
          );
        });

        that.setState({ loading: false });

        setTimeout(function () {
          history.push('/login');
        }.bind(this), 1300)
      })
      .catch(function (error) {
        const { response, message } = error;

        toast.error(() => {
          const errorMessage =
            response.status === 422 ? `Token ${response.data.errors.reset_password_token}` : message;

          return (
            <div>
              <FontAwesomeIcon icon="exclamation-triangle" />
              {errorMessage}
            </div>
          );
        });

        that.setState({ loading: false });

        console.log(error);
      });
  };

  render() {
    const { loading } = this.state;

    return (
      <PasswordContainer
        headerInstruction="Please enter your new password"
        loading={loading}
        buttonContent="Reset password"
        handleSubmit={this.handleSubmit}>
        <FormGroup>
          <Label for="password">New Password</Label>
          <Input
            id="password"
            name="password"
            type="password"
            minLength="6"
            placeholder="New Password"
            onChange={e => this.onChange(e)}
            onBlur={inputFocusHandler}
            required
          />
          <div className='row error' id='passwordError' />
        </FormGroup>
        <FormGroup>
          <Label for="confirmPassword">Confirm Password</Label>
          <Input
            id="confirmPassword"
            name="confirmPassword"
            type="password"
            placeholder="Confirm Password"
            onChange={e => this.onChange(e)}
            minLength="6"
            onBlur={inputFocusHandler}
            required
          />
          <div className='row error' id='confirmPasswordError' />
        </FormGroup>
      </PasswordContainer>
    );
  }
}

ResetPassword.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired
};

export default ResetPassword;



// WEBPACK FOOTER //
// ./src/components/users/UpdatePassword.js